import { entityTypeNameFor } from "@shapeable/utils";
import { usePageEntity } from "./use-page-entity";
import { useSite } from "./use-site";
import { useActiveEntityType } from "./use-active-entity-type";
import { useActiveEntityTypeNameOverride } from "../context/active-entity-type-name-override-context";
export var useExplorerParentView = function () {
  var site = useSite();
  var pageEntity = usePageEntity();
  var activeEntityTypeName = useActiveEntityType();
  var entityTypeName = entityTypeNameFor(pageEntity);
  var activeEntityTypeNameOverride = useActiveEntityTypeNameOverride();
  // Added activeEntityTypeNameOverride so that we can override the active Page entity for instances like in Gesda where certain
  // entities have been transformed into pseudo entities i.e Event entity has been transformed into Opportunity and Workshop
  // so we need a way to show the active tab for Opportunities as they're apart of the Explorer grid view but not Workshops.
  /* @ts-ignore */
  var actualEntityTypeName = entityTypeName === 'entity' ? activeEntityTypeName : activeEntityTypeNameOverride || entityTypeName;
  var _a = site.entityViews,
    entityViews = _a === void 0 ? [] : _a;
  // try to work out which tab is active, by finding the first view which lists the current entityTypeName in its childEntityTypes 
  var parentView = entityViews.find(function (view) {
    return (view.childEntityTypes || []).map(function (entityType) {
      return entityType.internalName || entityType.name;
    }).includes(actualEntityTypeName);
  });
  if (parentView) {
    return parentView;
  }
  return null;
};